<template>
  <div class="width" @keyup.enter="loginMethod">
    <b-container fluid class="auth">
      <h4 class="center">Войти в ПИ и Транзит</h4>
      <b-form class="login" @submit.prevent="loginMethod">
        <b-row class="my-1 b-center">
          <b-col md="3" class="mb-1">
            <b-form-input id="input-none" :state="true" type="text" placeholder="Логин"
                          v-model="form.username" required></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1 b-center">
          <b-col class="password-wrapper" md="3">
            <b-form-input id="input-valid" :state="true" type="password" placeholder="Пароль"
                          v-model="form.password" required></b-form-input>
            <span :class="showPassword?'show-password':'hide-password'" @click="togglePassword"></span>
          </b-col>
        </b-row>
        <b-row class="b-center" v-show="status==='error'">
          <b-col md="6">
            <b-alert show variant="danger">Пожалуйста, проверьте правильность написания логина и пароля.
            </b-alert>
          </b-col>
        </b-row>
        <b-row class="b-center">
          <b-col md="2">
            <b-button @click="loginMethod" id="log_in" class="login" variant="success">Войти</b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-container>
    <div class="footer-info">
      <div><p>&copy; ООО &laquo;CTM&raquo; {{ new Date().getFullYear() }}</p></div>
      <div><a target="_blank" href="https://www.ctm.ru/privacy.pdf">Политика обработки персональных данных и реализуемых требований к их защите в ООО «СТМ» (PDF)</a></div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import axios from 'axios'

  export default {
    name: 'Login',
    data () {
      return {
        showPassword: false,
        form: {
          username: '',
          password: ''
        },
        selected: null,
        options: [
          { value: null, text: 'Please select some item' },
          { value: 'a', text: 'This is option a' },
          { value: 'b', text: 'Default Selected Option b' },
          { value: 'c', text: 'This is option c' },
          { value: 'd', text: 'This one is disabled', disabled: true },
          { value: 'e', text: 'This is option e' },
          { value: 'e', text: 'This is option f' }
        ]
      }
    },
    mounted () {
      if (localStorage.getItem('token')) {
        localStorage.removeItem('token')
      }
      if (localStorage.getItem('userInfo')) {
        localStorage.removeItem('userInfo')
      }
      if (axios.defaults.headers.common.Authorization) {
        delete axios.defaults.headers.common.Authorization
      }
    },
    computed: {
      ...mapState({})
    },
    methods: {
      ...mapActions('authorization',
        [
          'login',
          'showUserInfo',
          'status'
        ]
      ),
      loginMethod () {
        this.login(this.form).then(
          () => {
            this.showUserInfo().then(
              () => {
                this.$router.push('/pi-transit')
              },
              error => {
                console.log(error)
              }
            )
          },
          error => {
            console.log(error)
          }
        )
      },
      togglePassword () {
        const inputPass = document.getElementById('input-valid')
        if (inputPass.type === 'password') {
          inputPass.type = 'text'
          this.showPassword = !this.showPassword
        } else {
          inputPass.type = 'password'
          this.showPassword = !this.showPassword
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  h4.center {
    text-align: center;
    margin-bottom: 30px;
  }

  .auth {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .width {
    width: 100vw;
    height: 100vh;
    display: flex;
    position: relative;
  }

  .login {
    min-width: 65px;
    text-align: center;
  }

  .login button {
    width: 100%;
    color: #ffffff;
  }

  .b-center {
    display: flex;
    justify-content: center;
    margin-top: 40px;
  }

  .alert {
    margin-bottom: 0;
    padding: 1.25rem 1.25rem;
  }

  span {
    width: 25px;
    height: 20px;
    display: block;
    position: absolute;
    top: 0.6rem;
    right: 1.25rem;
    &.show-password {
      background-image: url("../assets/icon-eye-close.svg");
      background-repeat: no-repeat;
    }
    &.hide-password {
      background-image: url("../assets/icon-eye-open.svg");
      background-repeat: no-repeat;
    }
  }

  .footer-info {
    position: absolute;
    bottom: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    width: 100%;
  }

  .password-wrapper {
    position: relative;
  }
</style>
